import { motion } from "framer-motion";
import { Arrow as ArrowLaag } from "react-laag";
import { type PopoverProps } from "./popover";
import { createShouldForwardPropBlockList } from "../utils/helper";
import styled from "styled-components";

type WrapperProps = Pick<PopoverProps, "list" | "size" | "datepicker" | "dateTimepicker"> & { useFullscreenMode: boolean };

export const Body = styled("div")(({ theme }) => ({
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.lg,
    overflow: "hidden",
}));

export const Wrapper = styled(motion.div).withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["list", "size", "datepicker", "dateTimepicker", "useFullscreenMode"]),
})<WrapperProps>(({ list, size, datepicker, dateTimepicker, useFullscreenMode, theme }) => ({
    width: "100%",
    maxWidth: useFullscreenMode ? "none" : "270px",
    zIndex: 1001,
    backgroundColor: theme.colors.white,
    color: theme.colors.gray[950],
    borderRadius: useFullscreenMode ? 0 : theme.borderRadius.lg,
    border: "none",
    boxShadow: theme.boxShadow["box-light"],
    padding: list ? `${theme.spacing[1.5]} ${theme.spacing[2]}` : undefined,
    ...(useFullscreenMode && {
        overflowY: "auto",
    }),
    ...(list && {
        [`& > ${Body}`]: {
            borderRadius: 0,
        },
    }),
    ...(size === "md" && {
        [`@media (min-width: ${theme.screens.md})`]: {
            maxWidth: useFullscreenMode ? "none" : "300px",
        },
    }),
    ...(size === "lg" && {
        [`@media (min-width: ${theme.screens.md})`]: {
            maxWidth: useFullscreenMode ? "none" : "430px",
        },
    }),
    ...(datepicker && {
        maxWidth: useFullscreenMode ? "none" : "300px",
    }),
    ...(dateTimepicker && {
        maxWidth: useFullscreenMode ? "none" : "300px",
        [`@media (min-width: ${theme.screens.md})`]: {
            maxWidth: useFullscreenMode ? "none" : "340px",
        },
        ".react-datepicker": {
            overflow: "hidden",
        },
        ".react-datepicker__month-container": {
            float: "left",
            width: "calc(100% - 80px)",
        },
        ".react-datepicker__time-container": {
            float: "left",
            width: "80px",
        },
    }),
    ...((datepicker || dateTimepicker) &&
        size === "lg" && {
            maxWidth: useFullscreenMode ? "none" : "300px",
            [`@media (min-width: ${theme.screens.md})`]: {
                maxWidth: useFullscreenMode ? "none" : "600px",
            },
            ".react-datepicker": {
                overflow: "hidden",
            },
            ".react-datepicker__month-container": {
                float: "left",
                width: "calc(50% - 12px)",
                "&:last-child": {
                    float: "right",
                    "&:before": {
                        content: '""',
                        position: "absolute",
                        left: "-12px",
                        top: "10px",
                        width: "1px",
                        height: "calc(100% - 12px)",
                        backgroundColor: theme.colors.gray[100],
                    },
                },
            },
        }),
}));

export const Arrow = styled(ArrowLaag)(() => ({
    zIndex: 100,
}));

export const Close = styled("div")(({ theme }) => ({
    position: "fixed",
    top: theme.spacing[2],
    right: theme.spacing[2],
    zIndex: 20,
}));
